import { GetYearMonthDay } from '../../../Public/Functions/GetDates';
import { ButtonsTransaction } from '../../Form/Buttons/ButtonsTransaction';

export const History = (props) => {
    const { entity, datas } = props;
    return (
        <div className="admin-list">
            <div className="title">
                <div>{`ADMIN: ${entity} (${datas.length})`}</div>
            </div>
            <div className="thead">
                <div className="block-rows">
                    <div className="id">id</div>
                    <div className="date">created</div>
                    <div className="name">name</div>
                </div>
                <div className="block-buttons"></div>
            </div>
            {datas.map((el, i) => {
                let created = GetYearMonthDay(el.created);
                return (
                    <div key={`i-${i}`} className="rows">
                        <div className="block-rows">
                            <div className="id">{i + 1}</div>
                            <div className="date">{created}</div>
                            <div className="name" title={el.title}>{el.title}<span className="id">({el.id})</span></div>
                        </div>
                        <ButtonsTransaction id={el.id} entity={entity} />
                    </div>
                )
            })}
        </div>
    )
} 